// import {
//   Close as CloseIcon,
//   AttachMoney as MoneyIcon,
//   TrendingUp as TrendingUpIcon
// } from '@mui/icons-material';
// import {
//   Alert,
//   Box,
//   Button,
//   Chip,
//   CircularProgress,
//   Divider,
//   FormControl,
//   Grid,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Modal,
//   Paper,
//   Select,
//   Snackbar,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import * as React from 'react';
// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { revaluateAsset } from 'slices/fundManagementInvestment/fundmanagementInvestmentSlice';
// import type { AppDispatch } from '../../../store';

// // Simplified interfaces based on API response
// interface Liability {
//   type: string;
//   provider: string;
//   amount: string;
//   rate: string;
//   monthlyPayment: string;
// }

// interface MonthlyIncome {
//   primary: string;
//   secondary: string;
//   other: string;
//   totalGrossIncome: string;
// }

// interface MonthlyExpenses {
//   financing: string;
//   management: string;
//   operational: string;
//   fees: string;
//   totalExpenses: string;
// }

// interface AssetData {
//   type: string;
//   subType: string;
//   identifier: string;
//   description: string;
//   purchaseValue: string;
//   cashUsed: string;
//   expectedAnnualYield: string;
//   monthlyIncome: MonthlyIncome;
//   monthlyExpenses: MonthlyExpenses;
//   netMonthlyIncome: string;
//   liabilities: Liability[];
//   additionalInfo: any;
//   currentValue?: string;
// }

// interface Asset {
//   assetId: string;
//   type: string;
//   assetData: AssetData;
//   cashUsed: string;
//   currentValue?: string;
//   purchaseDate: string;
//   fundManager: string;
// }

// interface RevaluationModalProps {
//   open: boolean;
//   onClose: () => void;
//   asset: Asset | null;
//   unitType: 'incomeUnits' | 'growthUnits';
//   onSuccess?: () => void;
//   serviceId?: string;
// }

// interface IncomeUnitsFormData {
//   primary: string;
//   secondary: string;
//   other: string;
//   financing: string;
//   management: string;
//   operational: string;
//   fees: string;
//   currentValue: string;
//   liability: Liability;
// }

// interface GrowthUnitsFormData {
//   primary: string;
//   secondary: string;
//   other: string;
//   currentValue: string;
//   financing: string;
//   management: string;
//   operational: string;
//   fees: string;
//   liability: Liability;
// }

// interface SnackbarState {
//   open: boolean;
//   message: string;
//   severity: 'success' | 'error' | 'warning' | 'info';
// }

// const RevaluationModal: React.FC<RevaluationModalProps> = ({
//   open,
//   onClose,
//   asset,
//   unitType,
//   onSuccess,
//   serviceId = 'fundManagementInvestment'
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const dispatch = useDispatch<AppDispatch>();
//   const [loading, setLoading] = useState<boolean>(false);

//   const selectedProjectId = useSelector(
//     (state: any) => state.homeTilesServices.selectedProjectId || ''
//   );

//   const [snackbar, setSnackbar] = useState<SnackbarState>({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   const defaultLiability: Liability = {
//     type: 'financing',
//     provider: '',
//     amount: '',
//     rate: '',
//     monthlyPayment: ''
//   };

//   const [growthFormData, setGrowthFormData] = useState<GrowthUnitsFormData>({
//     primary: '',
//     secondary: '',
//     other: '',
//     currentValue: '',
//     financing: '',
//     management: '',
//     operational: '',
//     fees: '',
//     liability: defaultLiability
//   });

//   const [incomeFormData, setIncomeFormData] = useState<IncomeUnitsFormData>({
//     primary: '',
//     secondary: '',
//     other: '',
//     financing: '',
//     management: '',
//     operational: '',
//     fees: '',
//     currentValue: '',
//     liability: defaultLiability
//   });

//   useEffect(() => {
//     if (asset) {
//       const existingLiability = asset.assetData.liabilities?.[0] || defaultLiability;

//       if (unitType === 'growthUnits') {
//         setGrowthFormData({
//           primary: asset.assetData.monthlyIncome.primary || '',
//           secondary: asset.assetData.monthlyIncome.secondary || '',
//           other: asset.assetData.monthlyIncome.other || '',
//           currentValue: asset.currentValue || asset.assetData.purchaseValue || '',
//           financing: asset.assetData.monthlyExpenses.financing || '',
//           management: asset.assetData.monthlyExpenses.management || '',
//           operational: asset.assetData.monthlyExpenses.operational || '',
//           fees: asset.assetData.monthlyExpenses.fees || '',
//           liability: existingLiability
//         });
//       } else {
//         setIncomeFormData({
//           primary: asset.assetData.monthlyIncome.primary || '',
//           secondary: asset.assetData.monthlyIncome.secondary || '',
//           other: asset.assetData.monthlyIncome.other || '',
//           financing: asset.assetData.monthlyExpenses.financing || '',
//           management: asset.assetData.monthlyExpenses.management || '',
//           operational: asset.assetData.monthlyExpenses.operational || '',
//           fees: asset.assetData.monthlyExpenses.fees || '',
//           currentValue: asset.currentValue || asset.assetData.purchaseValue || '',
//           liability: existingLiability
//         });
//       }
//     }
//   }, [asset, unitType]);

//   // Simple auto-calculation functions
//   const calculateTotalIncome = (formData: GrowthUnitsFormData | IncomeUnitsFormData): number => {
//     const { primary, secondary, other } = formData;
//     const total =
//       (parseFloat(primary) || 0) + (parseFloat(secondary) || 0) + (parseFloat(other) || 0);
//     return parseFloat(total.toFixed(2));
//   };

//   const calculateTotalExpenses = (formData: GrowthUnitsFormData | IncomeUnitsFormData): number => {
//     const { financing, management, operational, fees } = formData;
//     const total =
//       (parseFloat(financing) || 0) +
//       (parseFloat(management) || 0) +
//       (parseFloat(operational) || 0) +
//       (parseFloat(fees) || 0);
//     return parseFloat(total.toFixed(2));
//   };

//   const calculateNetMonthlyIncome = (income: number, expenses: number): number => {
//     return parseFloat((income - expenses).toFixed(2));
//   };

//   // Auto-calculate monthly payment when liability amount or rate changes
//   const calculateMonthlyPayment = (amount: string, rate: string): string => {
//     const principal = parseFloat(amount) || 0;
//     const annualRate = parseFloat(rate.replace('%', '')) || 0;

//     if (principal <= 0 || annualRate <= 0) return '';

//     const monthlyRate = annualRate / 100 / 12;
//     const numPayments = 30 * 12; // Assuming 30-year loan

//     const monthlyPayment =
//       (principal * (monthlyRate * Math.pow(1 + monthlyRate, numPayments))) /
//       (Math.pow(1 + monthlyRate, numPayments) - 1);

//     return monthlyPayment.toFixed(2);
//   };

//   // Auto-sync financing expense with liability monthly payment
//   const syncFinancingWithLiability = (monthlyPayment: string, formData: any, setFormData: any) => {
//     setFormData((prev: any) => ({
//       ...prev,
//       financing: monthlyPayment
//     }));
//   };

//   const updateGrowthLiability = (field: keyof Liability, value: string) => {
//     setGrowthFormData((prev: GrowthUnitsFormData) => {
//       const updatedLiability = {
//         ...prev.liability,
//         [field]: value
//       };

//       // Auto-calculate monthly payment when amount or rate changes
//       if (field === 'amount' || field === 'rate') {
//         const monthlyPayment = calculateMonthlyPayment(
//           updatedLiability.amount,
//           updatedLiability.rate
//         );
//         updatedLiability.monthlyPayment = monthlyPayment;

//         // Auto-sync financing expense with monthly payment
//         setTimeout(() => {
//           syncFinancingWithLiability(monthlyPayment, growthFormData, setGrowthFormData);
//         }, 0);
//       }

//       return {
//         ...prev,
//         liability: updatedLiability
//       };
//     });
//   };

//   const updateIncomeLiability = (field: keyof Liability, value: string) => {
//     setIncomeFormData((prev: IncomeUnitsFormData) => {
//       const updatedLiability = {
//         ...prev.liability,
//         [field]: value
//       };

//       // Auto-calculate monthly payment when amount or rate changes
//       if (field === 'amount' || field === 'rate') {
//         const monthlyPayment = calculateMonthlyPayment(
//           updatedLiability.amount,
//           updatedLiability.rate
//         );
//         updatedLiability.monthlyPayment = monthlyPayment;

//         // Auto-sync financing expense with monthly payment
//         setTimeout(() => {
//           syncFinancingWithLiability(monthlyPayment, incomeFormData, setIncomeFormData);
//         }, 0);
//       }

//       return {
//         ...prev,
//         liability: updatedLiability
//       };
//     });
//   };

//   const createUpdatedAssetObject = (): Asset => {
//     if (!asset) throw new Error('Asset is required');

//     const baseAsset = { ...asset };

//     if (unitType === 'growthUnits') {
//       const totalIncome = calculateTotalIncome(growthFormData);
//       const totalExpenses = calculateTotalExpenses(growthFormData);
//       const netMonthlyIncome = calculateNetMonthlyIncome(totalIncome, totalExpenses);

//       return {
//         ...baseAsset,
//         currentValue: growthFormData.currentValue,
//         assetData: {
//           ...baseAsset.assetData,
//           currentValue: growthFormData.currentValue,
//           monthlyIncome: {
//             ...baseAsset.assetData.monthlyIncome,
//             primary: growthFormData.primary,
//             secondary: growthFormData.secondary,
//             other: growthFormData.other,
//             totalGrossIncome: totalIncome.toString()
//           },
//           monthlyExpenses: {
//             ...baseAsset.assetData.monthlyExpenses,
//             financing: growthFormData.financing,
//             management: growthFormData.management,
//             operational: growthFormData.operational,
//             fees: growthFormData.fees,
//             totalExpenses: totalExpenses.toString()
//           },
//           netMonthlyIncome: netMonthlyIncome.toString(),
//           liabilities: [growthFormData.liability]
//         }
//       };
//     } else {
//       const totalIncome = calculateTotalIncome(incomeFormData);
//       const totalExpenses = calculateTotalExpenses(incomeFormData);
//       const netMonthlyIncome = calculateNetMonthlyIncome(totalIncome, totalExpenses);

//       return {
//         ...baseAsset,
//         currentValue: incomeFormData.currentValue,
//         assetData: {
//           ...baseAsset.assetData,
//           currentValue: incomeFormData.currentValue,
//           monthlyIncome: {
//             ...baseAsset.assetData.monthlyIncome,
//             primary: incomeFormData.primary,
//             secondary: incomeFormData.secondary,
//             other: incomeFormData.other,
//             totalGrossIncome: totalIncome.toString()
//           },
//           monthlyExpenses: {
//             ...baseAsset.assetData.monthlyExpenses,
//             financing: incomeFormData.financing,
//             management: incomeFormData.management,
//             operational: incomeFormData.operational,
//             fees: incomeFormData.fees,
//             totalExpenses: totalExpenses.toString()
//           },
//           netMonthlyIncome: netMonthlyIncome.toString(),
//           liabilities: [incomeFormData.liability]
//         }
//       };
//     }
//   };

//   const handleSubmit = async () => {
//     if (!asset) return;

//     setLoading(true);
//     try {
//       const updatedAsset = createUpdatedAssetObject();

//       const payload = {
//         groupId: selectedProjectId || '',
//         serviceId,
//         unitType,
//         asset: updatedAsset
//       };

//       console.log('Revaluation Payload:', JSON.stringify(payload, null, 2));

//       const result = await dispatch(revaluateAsset(payload));

//       if (revaluateAsset.fulfilled.match(result)) {
//         showSnackbar(
//           `${
//             unitType === 'growthUnits' ? 'Growth' : 'Income'
//           } asset revaluation submitted successfully!`,
//           'success'
//         );
//         onSuccess?.();

//         setTimeout(() => {
//           handleClose();
//         }, 1500);
//       } else if (revaluateAsset.rejected.match(result)) {
//         const errorMessage = result.payload || 'Failed to submit revaluation';
//         showSnackbar(errorMessage, 'error');
//         console.error('Revaluation error:', errorMessage);
//       }
//     } catch (error: any) {
//       showSnackbar(error?.message || 'Failed to submit revaluation', 'error');
//       console.error('Revaluation error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     if (!loading) {
//       onClose();
//       setGrowthFormData({
//         primary: '',
//         secondary: '',
//         other: '',
//         currentValue: '',
//         financing: '',
//         management: '',
//         operational: '',
//         fees: '',
//         liability: defaultLiability
//       });
//       setIncomeFormData({
//         primary: '',
//         secondary: '',
//         other: '',
//         financing: '',
//         management: '',
//         operational: '',
//         fees: '',
//         currentValue: '',
//         liability: defaultLiability
//       });
//       setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }));
//     }
//   };

//   const showSnackbar = (message: string, severity: SnackbarState['severity'] = 'success') => {
//     setSnackbar({
//       open: true,
//       message,
//       severity
//     });
//   };

//   const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }));
//   };

//   const formatCurrency = (amount: string | number): string => {
//     return new Intl.NumberFormat('en-AU', {
//       style: 'currency',
//       currency: 'AUD'
//     }).format(Number(amount) || 0);
//   };

//   const getTextFieldStyles = () => ({
//     '& .MuiInputLabel-root': {
//       fontSize: { xs: '0.75rem', md: '0.875rem' }
//     },
//     '& .MuiInputBase-input': {
//       fontSize: { xs: '0.75rem', md: '0.875rem' },
//       py: { xs: 1, md: 1.25 }
//     }
//   });

//   const getSummaryBoxStyles = (bgColor: string, borderColor: string) => ({
//     p: { xs: 1.5, md: 2 },
//     bgcolor: bgColor,
//     borderRadius: 1,
//     border: 1,
//     borderColor: borderColor,
//     mb: { xs: 1.5, md: 2 }
//   });

//   const renderStaticInformation = () => (
//     <Box sx={{ mb: { xs: 2, md: 3 } }}>
//       <Typography
//         variant="subtitle2"
//         gutterBottom
//         sx={{
//           mb: { xs: 1, md: 1.5 },
//           color: 'text.secondary',
//           fontSize: { xs: '0.8rem', md: '0.9rem' },
//           fontWeight: 600
//         }}
//       >
//         Asset Information (Unchanged)
//       </Typography>
//       <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

//       <Grid container spacing={{ xs: 2, md: 3 }}>
//         <Grid item xs={12} sm={4}>
//           <Box sx={{ p: { xs: 1.5, md: 2 }, bgcolor: 'grey.50', borderRadius: 1 }}>
//             <Typography variant="caption" color="text.secondary" display="block">
//               Asset Type
//             </Typography>
//             <Typography variant="body2" fontWeight={500} sx={{ textTransform: 'capitalize' }}>
//               {asset?.type}
//             </Typography>
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm={4}>
//           <Box sx={{ p: { xs: 1.5, md: 2 }, bgcolor: 'grey.50', borderRadius: 1 }}>
//             <Typography variant="caption" color="text.secondary" display="block">
//               Purchase Value
//             </Typography>
//             <Typography variant="body2" fontWeight={500} color="primary.main">
//               {asset ? formatCurrency(asset.assetData.purchaseValue) : ''}
//             </Typography>
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm={4}>
//           <Box sx={{ p: { xs: 1.5, md: 2 }, bgcolor: 'grey.50', borderRadius: 1 }}>
//             <Typography variant="caption" color="text.secondary" display="block">
//               Cash Used (Original)
//             </Typography>
//             <Typography variant="body2" fontWeight={500} color="primary.main">
//               {asset ? formatCurrency(asset.assetData.cashUsed) : ''}
//             </Typography>
//           </Box>
//         </Grid>
//       </Grid>
//     </Box>
//   );

//   const renderMonthlyIncomeSection = (
//     formData: GrowthUnitsFormData | IncomeUnitsFormData,
//     setFormData: any
//   ) => (
//     <Box sx={{ mb: { xs: 2, md: 3 } }}>
//       <Typography
//         variant="subtitle2"
//         gutterBottom
//         sx={{
//           mb: { xs: 1, md: 1.5 },
//           fontSize: { xs: '0.8rem', md: '0.9rem' },
//           fontWeight: 600
//         }}
//       >
//         Monthly Income
//       </Typography>
//       <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

//       <Grid container spacing={{ xs: 2, md: 3 }}>
//         <Grid item xs={12} sm={4}>
//           <TextField
//             fullWidth
//             label="Primary Income"
//             type="number"
//             size="small"
//             inputProps={{ step: '0.01' }}
//             value={formData.primary}
//             onChange={(e) =>
//               setFormData((prev: any) => ({
//                 ...prev,
//                 primary: e.target.value
//               }))
//             }
//             InputProps={{
//               startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//             }}
//             sx={getTextFieldStyles()}
//           />
//         </Grid>

//         <Grid item xs={12} sm={4}>
//           <TextField
//             fullWidth
//             label="Secondary Income"
//             type="number"
//             size="small"
//             inputProps={{ step: '0.01' }}
//             value={formData.secondary}
//             onChange={(e) =>
//               setFormData((prev: any) => ({
//                 ...prev,
//                 secondary: e.target.value
//               }))
//             }
//             InputProps={{
//               startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//             }}
//             sx={getTextFieldStyles()}
//           />
//         </Grid>

//         <Grid item xs={12} sm={4}>
//           <TextField
//             fullWidth
//             label="Other Income"
//             type="number"
//             size="small"
//             inputProps={{ step: '0.01' }}
//             value={formData.other}
//             onChange={(e) =>
//               setFormData((prev: any) => ({
//                 ...prev,
//                 other: e.target.value
//               }))
//             }
//             InputProps={{
//               startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//             }}
//             sx={getTextFieldStyles()}
//           />
//         </Grid>
//       </Grid>

//       {/* Auto-calculated Total Gross Income */}
//       <Box sx={getSummaryBoxStyles('success.50', 'success.200')}>
//         <Typography variant="body2" color="success.main" fontWeight={600}>
//           Total Gross Income: {formatCurrency(calculateTotalIncome(formData))}
//         </Typography>
//       </Box>
//     </Box>
//   );

//   const renderLiabilitySection = (
//     liability: Liability,
//     updateLiability: (field: keyof Liability, value: string) => void
//   ) => (
//     <Box sx={{ mt: { xs: 2, md: 3 } }}>
//       <Typography
//         variant="subtitle2"
//         gutterBottom
//         sx={{
//           mb: { xs: 1, md: 1.5 },
//           fontSize: { xs: '0.8rem', md: '0.9rem' },
//           fontWeight: 600
//         }}
//       >
//         Liability Information
//       </Typography>
//       <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

//       <Grid container spacing={{ xs: 2, md: 3 }}>
//         <Grid item xs={12} sm={6}>
//           <FormControl fullWidth size="small">
//             <InputLabel>Liability Type</InputLabel>
//             <Select
//               value={liability.type}
//               label="Liability Type"
//               onChange={(e) => updateLiability('type', e.target.value)}
//               sx={getTextFieldStyles()}
//             >
//               <MenuItem value="financing">Financing</MenuItem>
//               <MenuItem value="mortgage">Mortgage</MenuItem>
//               <MenuItem value="loan">Loan</MenuItem>
//               <MenuItem value="other">Other</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>

//         <Grid item xs={12} sm={6}>
//           <TextField
//             fullWidth
//             label="Provider"
//             size="small"
//             value={liability.provider}
//             onChange={(e) => updateLiability('provider', e.target.value)}
//             sx={getTextFieldStyles()}
//           />
//         </Grid>

//         <Grid item xs={12} sm={4}>
//           <TextField
//             fullWidth
//             label="Liability Amount"
//             type="number"
//             size="small"
//             inputProps={{ step: '0.01' }}
//             value={liability.amount}
//             onChange={(e) => updateLiability('amount', e.target.value)}
//             InputProps={{
//               startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//             }}
//             sx={getTextFieldStyles()}
//           />
//         </Grid>

//         <Grid item xs={12} sm={4}>
//           <TextField
//             fullWidth
//             label="Interest Rate"
//             size="small"
//             value={liability.rate}
//             onChange={(e) => updateLiability('rate', e.target.value)}
//             InputProps={{
//               endAdornment: <span style={{ marginLeft: 4, color: 'gray' }}>%</span>
//             }}
//             sx={getTextFieldStyles()}
//           />
//         </Grid>

//         <Grid item xs={12} sm={4}>
//           <TextField
//             fullWidth
//             label="Monthly Payment"
//             type="number"
//             size="small"
//             inputProps={{ step: '0.01' }}
//             value={liability.monthlyPayment}
//             onChange={(e) => updateLiability('monthlyPayment', e.target.value)}
//             InputProps={{
//               startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//             }}
//             helperText="Auto-calculated when amount & rate entered"
//             sx={{
//               ...getTextFieldStyles(),
//               '& .MuiInputBase-input': {
//                 ...getTextFieldStyles()['& .MuiInputBase-input'],
//                 bgcolor:
//                   liability.monthlyPayment && liability.amount && liability.rate
//                     ? 'action.hover'
//                     : 'inherit'
//               }
//             }}
//           />
//         </Grid>
//       </Grid>

//       {/* Show calculation hint */}
//       {liability.amount && liability.rate && (
//         <Box sx={{ mt: 1 }}>
//           <Typography variant="caption" color="info.main">
//             💡 Monthly payment auto-calculated. Financing expense will be synced automatically.
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );

//   const renderGrowthUnitsForm = () => (
//     <Box>
//       {renderStaticInformation()}

//       <Box sx={{ mb: { xs: 2, md: 3 } }}>
//         <Typography
//           variant="subtitle2"
//           gutterBottom
//           sx={{
//             mb: { xs: 1, md: 1.5 },
//             fontSize: { xs: '0.8rem', md: '0.9rem' },
//             fontWeight: 600
//           }}
//         >
//           Asset Valuation
//         </Typography>
//         <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

//         <TextField
//           fullWidth
//           label="Current Value*"
//           type="number"
//           size="small"
//           inputProps={{ step: '0.01' }}
//           value={growthFormData.currentValue}
//           onChange={(e) =>
//             setGrowthFormData((prev) => ({
//               ...prev,
//               currentValue: e.target.value
//             }))
//           }
//           InputProps={{
//             startAdornment: <MoneyIcon sx={{ mr: 0.5, color: 'text.secondary' }} />
//           }}
//           helperText="Enter the updated current value of the asset"
//           sx={{ ...getTextFieldStyles(), maxWidth: { sm: 400 } }}
//         />
//       </Box>

//       {renderMonthlyIncomeSection(growthFormData, setGrowthFormData)}

//       <Box sx={{ mb: { xs: 2, md: 3 } }}>
//         <Typography
//           variant="subtitle2"
//           gutterBottom
//           sx={{
//             mb: { xs: 1, md: 1.5 },
//             fontSize: { xs: '0.8rem', md: '0.9rem' },
//             fontWeight: 600
//           }}
//         >
//           Monthly Expenses
//         </Typography>
//         <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

//         <Grid container spacing={{ xs: 2, md: 3 }}>
//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Financing"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={growthFormData.financing}
//               onChange={(e) =>
//                 setGrowthFormData((prev) => ({
//                   ...prev,
//                   financing: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               helperText="Syncs with liability payment"
//               sx={{
//                 ...getTextFieldStyles(),
//                 '& .MuiInputBase-input': {
//                   bgcolor: growthFormData.liability.monthlyPayment ? 'action.hover' : 'inherit'
//                 }
//               }}
//             />
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Management"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={growthFormData.management}
//               onChange={(e) =>
//                 setGrowthFormData((prev) => ({
//                   ...prev,
//                   management: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               sx={getTextFieldStyles()}
//             />
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Operational"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={growthFormData.operational}
//               onChange={(e) =>
//                 setGrowthFormData((prev) => ({
//                   ...prev,
//                   operational: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               sx={getTextFieldStyles()}
//             />
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Fees"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={growthFormData.fees}
//               onChange={(e) =>
//                 setGrowthFormData((prev) => ({
//                   ...prev,
//                   fees: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               sx={getTextFieldStyles()}
//             />
//           </Grid>
//         </Grid>

//         {/* Auto-calculated totals */}
//         <Box sx={getSummaryBoxStyles('grey.50', 'grey.200')}>
//           <Typography variant="body2" color="primary" fontWeight={600}>
//             Total Monthly Expenses: {formatCurrency(calculateTotalExpenses(growthFormData))}
//           </Typography>
//         </Box>

//         <Box sx={getSummaryBoxStyles('info.50', 'info.200')}>
//           <Typography variant="body2" color="info.main" fontWeight={600}>
//             Net Monthly Income:{' '}
//             {formatCurrency(
//               calculateNetMonthlyIncome(
//                 calculateTotalIncome(growthFormData),
//                 calculateTotalExpenses(growthFormData)
//               )
//             )}
//           </Typography>
//         </Box>
//       </Box>

//       {renderLiabilitySection(growthFormData.liability, updateGrowthLiability)}
//     </Box>
//   );

//   const renderIncomeUnitsForm = () => (
//     <Box>
//       {renderStaticInformation()}

//       <Box sx={{ mb: { xs: 2, md: 3 } }}>
//         <Typography
//           variant="subtitle2"
//           gutterBottom
//           sx={{
//             mb: { xs: 1, md: 1.5 },
//             fontSize: { xs: '0.8rem', md: '0.9rem' },
//             fontWeight: 600
//           }}
//         >
//           Asset Valuation
//         </Typography>
//         <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

//         <TextField
//           fullWidth
//           label="Current Value"
//           type="number"
//           size="small"
//           inputProps={{ step: '0.01' }}
//           value={incomeFormData.currentValue}
//           onChange={(e) =>
//             setIncomeFormData((prev) => ({
//               ...prev,
//               currentValue: e.target.value
//             }))
//           }
//           InputProps={{
//             startAdornment: <MoneyIcon sx={{ mr: 0.5, color: 'text.secondary' }} />
//           }}
//           helperText="Enter the updated current value of the asset"
//           sx={{ ...getTextFieldStyles(), maxWidth: { sm: 400 } }}
//         />
//       </Box>

//       {renderMonthlyIncomeSection(incomeFormData, setIncomeFormData)}

//       <Box sx={{ mb: { xs: 2, md: 3 } }}>
//         <Typography
//           variant="subtitle2"
//           gutterBottom
//           sx={{
//             mb: { xs: 1, md: 1.5 },
//             fontSize: { xs: '0.8rem', md: '0.9rem' },
//             fontWeight: 600
//           }}
//         >
//           Monthly Expenses
//         </Typography>
//         <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

//         <Grid container spacing={{ xs: 2, md: 3 }}>
//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Financing"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={incomeFormData.financing}
//               onChange={(e) =>
//                 setIncomeFormData((prev) => ({
//                   ...prev,
//                   financing: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               helperText="Syncs with liability payment"
//               sx={{
//                 ...getTextFieldStyles(),
//                 '& .MuiInputBase-input': {
//                   bgcolor: incomeFormData.liability.monthlyPayment ? 'action.hover' : 'inherit'
//                 }
//               }}
//             />
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Management"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={incomeFormData.management}
//               onChange={(e) =>
//                 setIncomeFormData((prev) => ({
//                   ...prev,
//                   management: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               sx={getTextFieldStyles()}
//             />
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Operational"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={incomeFormData.operational}
//               onChange={(e) =>
//                 setIncomeFormData((prev) => ({
//                   ...prev,
//                   operational: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               sx={getTextFieldStyles()}
//             />
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <TextField
//               fullWidth
//               label="Fees"
//               type="number"
//               size="small"
//               inputProps={{ step: '0.01' }}
//               value={incomeFormData.fees}
//               onChange={(e) =>
//                 setIncomeFormData((prev) => ({
//                   ...prev,
//                   fees: e.target.value
//                 }))
//               }
//               InputProps={{
//                 startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
//               }}
//               sx={getTextFieldStyles()}
//             />
//           </Grid>
//         </Grid>

//         <Box sx={getSummaryBoxStyles('grey.50', 'grey.200')}>
//           <Typography variant="body2" color="primary" fontWeight={600}>
//             Total Monthly Expenses: {formatCurrency(calculateTotalExpenses(incomeFormData))}
//           </Typography>
//         </Box>

//         <Box sx={getSummaryBoxStyles('info.50', 'info.200')}>
//           <Typography variant="body2" color="info.main" fontWeight={600}>
//             Net Monthly Income:{' '}
//             {formatCurrency(
//               calculateNetMonthlyIncome(
//                 calculateTotalIncome(incomeFormData),
//                 calculateTotalExpenses(incomeFormData)
//               )
//             )}
//           </Typography>
//         </Box>
//       </Box>

//       {renderLiabilitySection(incomeFormData.liability, updateIncomeLiability)}
//     </Box>
//   );

//   const isFormValid = () => {
//     if (unitType === 'growthUnits') {
//       return growthFormData.currentValue.trim() !== '';
//     }
//     return true;
//   };

//   if (!asset) return null;

//   return (
//     <>
//       <Modal open={open} onClose={handleClose} aria-labelledby="revaluation-modal-title">
//         <Paper
//           sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: { xs: '95%', sm: 700, md: 900 },
//             maxWidth: '95vw',
//             maxHeight: '90vh',
//             overflow: 'auto',
//             p: 0,
//             borderRadius: { xs: 1, md: 2 }
//           }}
//         >
//           <Box
//             sx={{
//               p: { xs: 2, md: 3 },
//               borderBottom: 1,
//               borderColor: 'divider',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               bgcolor: 'grey.50'
//             }}
//           >
//             <Box display="flex" alignItems="center" gap={2}>
//               {unitType === 'growthUnits' ? (
//                 <TrendingUpIcon color="primary" sx={{ fontSize: '1.5rem' }} />
//               ) : (
//                 <MoneyIcon color="primary" sx={{ fontSize: '1.5rem' }} />
//               )}
//               <Box>
//                 <Typography
//                   variant="h6"
//                   component="h2"
//                   sx={{ fontSize: { xs: '1.1rem', md: '1.3rem' }, fontWeight: 600, mb: 0.5 }}
//                 >
//                   {unitType === 'growthUnits' ? 'Growth' : 'Income'} Asset Revaluation
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
//                   {asset.assetData.identifier}
//                 </Typography>
//               </Box>
//             </Box>

//             <Box display="flex" alignItems="center" gap={1}>
//               <Chip
//                 label={unitType === 'growthUnits' ? 'Growth Unit' : 'Income Unit'}
//                 size="small"
//                 color="primary"
//                 variant="outlined"
//               />
//               <IconButton onClick={handleClose} size="small" disabled={loading}>
//                 <CloseIcon fontSize="small" />
//               </IconButton>
//             </Box>
//           </Box>

//           <Box sx={{ p: { xs: 2, md: 3 } }}>
//             {unitType === 'growthUnits' ? renderGrowthUnitsForm() : renderIncomeUnitsForm()}

//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'flex-end',
//                 gap: 2,
//                 mt: 4,
//                 pt: 2,
//                 borderTop: 1,
//                 borderColor: 'divider'
//               }}
//             >
//               <Button
//                 variant="outlined"
//                 onClick={handleClose}
//                 disabled={loading}
//                 sx={{ minWidth: 100 }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={handleSubmit}
//                 disabled={loading || !isFormValid()}
//                 startIcon={loading && <CircularProgress size={20} />}
//                 sx={{ minWidth: 150 }}
//               >
//                 {loading ? 'Submitting...' : 'Submit Revaluation'}
//               </Button>
//             </Box>
//           </Box>
//         </Paper>
//       </Modal>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled">
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default RevaluationModal;


import {
  Close as CloseIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { revaluateAsset } from 'slices/fundManagementInvestment/fundmanagementInvestmentSlice';
import type { AppDispatch } from '../../../store';

// Simplified interfaces based on API response
interface Liability {
  type: string;
  provider: string;
  amount: string;
  rate: string;
  monthlyPayment: string;
}

interface MonthlyIncome {
  primary: string;
  secondary: string;
  other: string;
  totalGrossIncome: string;
}

interface MonthlyExpenses {
  financing: string;
  management: string;
  operational: string;
  fees: string;
  totalExpenses: string;
}

interface AssetData {
  type: string;
  subType: string;
  identifier: string;
  description: string;
  purchaseValue: string;
  cashUsed: string;
  expectedAnnualYield: string;
  monthlyIncome: MonthlyIncome;
  monthlyExpenses: MonthlyExpenses;
  netMonthlyIncome: string;
  liabilities: Liability[];
  additionalInfo: any;
  currentValue?: string;
}

interface Asset {
  assetId: string;
  type: string;
  assetData: AssetData;
  cashUsed: string;
  currentValue?: string;
  purchaseDate: string;
  fundManager: string;
}

interface RevaluationModalProps {
  open: boolean;
  onClose: () => void;
  asset: Asset | null;
  unitType: 'incomeUnits' | 'growthUnits';
  onSuccess?: () => void;
  serviceId?: string;
}

interface IncomeUnitsFormData {
  primary: string;
  secondary: string;
  other: string;
  financing: string;
  management: string;
  operational: string;
  fees: string;
  currentValue: string;
  liability: Liability;
}

// Updated interface - removed income fields for growth units
interface GrowthUnitsFormData {
  currentValue: string;
  financing: string;
  management: string;
  operational: string;
  fees: string;
  liability: Liability;
}

interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

const RevaluationModal: React.FC<RevaluationModalProps> = ({
  open,
  onClose,
  asset,
  unitType,
  onSuccess,
  serviceId = 'fundManagementInvestment'
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState<boolean>(false);

  const selectedProjectId = useSelector(
    (state: any) => state.homeTilesServices.selectedProjectId || ''
  );

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success'
  });

  const defaultLiability: Liability = {
    type: 'financing',
    provider: '',
    amount: '',
    rate: '',
    monthlyPayment: ''
  };

  // Updated growth form data - removed income fields
  const [growthFormData, setGrowthFormData] = useState<GrowthUnitsFormData>({
    currentValue: '',
    financing: '',
    management: '',
    operational: '',
    fees: '',
    liability: defaultLiability
  });

  const [incomeFormData, setIncomeFormData] = useState<IncomeUnitsFormData>({
    primary: '',
    secondary: '',
    other: '',
    financing: '',
    management: '',
    operational: '',
    fees: '',
    currentValue: '',
    liability: defaultLiability
  });

  useEffect(() => {
    if (asset) {
      const existingLiability = asset.assetData.liabilities?.[0] || defaultLiability;

      if (unitType === 'growthUnits') {
        // Only set expense and valuation fields for growth units
        setGrowthFormData({
          currentValue: asset.currentValue || asset.assetData.purchaseValue || '',
          financing: asset.assetData.monthlyExpenses.financing || '',
          management: asset.assetData.monthlyExpenses.management || '',
          operational: asset.assetData.monthlyExpenses.operational || '',
          fees: asset.assetData.monthlyExpenses.fees || '',
          liability: existingLiability
        });
      } else {
        setIncomeFormData({
          primary: asset.assetData.monthlyIncome.primary || '',
          secondary: asset.assetData.monthlyIncome.secondary || '',
          other: asset.assetData.monthlyIncome.other || '',
          financing: asset.assetData.monthlyExpenses.financing || '',
          management: asset.assetData.monthlyExpenses.management || '',
          operational: asset.assetData.monthlyExpenses.operational || '',
          fees: asset.assetData.monthlyExpenses.fees || '',
          currentValue: asset.currentValue || asset.assetData.purchaseValue || '',
          liability: existingLiability
        });
      }
    }
  }, [asset, unitType]);

  // Simple auto-calculation functions
  const calculateTotalIncome = (formData: IncomeUnitsFormData): number => {
    const { primary, secondary, other } = formData;
    const total =
      (parseFloat(primary) || 0) + (parseFloat(secondary) || 0) + (parseFloat(other) || 0);
    return parseFloat(total.toFixed(2));
  };

  const calculateTotalExpenses = (formData: GrowthUnitsFormData | IncomeUnitsFormData): number => {
    const { financing, management, operational, fees } = formData;
    const total =
      (parseFloat(financing) || 0) +
      (parseFloat(management) || 0) +
      (parseFloat(operational) || 0) +
      (parseFloat(fees) || 0);
    return parseFloat(total.toFixed(2));
  };

  const calculateNetMonthlyIncome = (income: number, expenses: number): number => {
    return parseFloat((income - expenses).toFixed(2));
  };

  // Auto-calculate monthly payment when liability amount or rate changes
  const calculateMonthlyPayment = (amount: string, rate: string): string => {
    const principal = parseFloat(amount) || 0;
    const annualRate = parseFloat(rate.replace('%', '')) || 0;

    if (principal <= 0 || annualRate <= 0) return '';

    const monthlyRate = annualRate / 100 / 12;
    const numPayments = 30 * 12; // Assuming 30-year loan

    const monthlyPayment =
      (principal * (monthlyRate * Math.pow(1 + monthlyRate, numPayments))) /
      (Math.pow(1 + monthlyRate, numPayments) - 1);

    return monthlyPayment.toFixed(2);
  };

  // Auto-sync financing expense with liability monthly payment
  const syncFinancingWithLiability = (monthlyPayment: string, formData: any, setFormData: any) => {
    setFormData((prev: any) => ({
      ...prev,
      financing: monthlyPayment
    }));
  };

  const updateGrowthLiability = (field: keyof Liability, value: string) => {
    setGrowthFormData((prev: GrowthUnitsFormData) => {
      const updatedLiability = {
        ...prev.liability,
        [field]: value
      };

      // Auto-calculate monthly payment when amount or rate changes
      if (field === 'amount' || field === 'rate') {
        const monthlyPayment = calculateMonthlyPayment(
          updatedLiability.amount,
          updatedLiability.rate
        );
        updatedLiability.monthlyPayment = monthlyPayment;

        // Auto-sync financing expense with monthly payment
        setTimeout(() => {
          syncFinancingWithLiability(monthlyPayment, growthFormData, setGrowthFormData);
        }, 0);
      }

      return {
        ...prev,
        liability: updatedLiability
      };
    });
  };

  const updateIncomeLiability = (field: keyof Liability, value: string) => {
    setIncomeFormData((prev: IncomeUnitsFormData) => {
      const updatedLiability = {
        ...prev.liability,
        [field]: value
      };

      // Auto-calculate monthly payment when amount or rate changes
      if (field === 'amount' || field === 'rate') {
        const monthlyPayment = calculateMonthlyPayment(
          updatedLiability.amount,
          updatedLiability.rate
        );
        updatedLiability.monthlyPayment = monthlyPayment;

        // Auto-sync financing expense with monthly payment
        setTimeout(() => {
          syncFinancingWithLiability(monthlyPayment, incomeFormData, setIncomeFormData);
        }, 0);
      }

      return {
        ...prev,
        liability: updatedLiability
      };
    });
  };

  const createUpdatedAssetObject = (): Asset => {
    if (!asset) throw new Error('Asset is required');

    const baseAsset = { ...asset };

    if (unitType === 'growthUnits') {
      const totalExpenses = calculateTotalExpenses(growthFormData);
      // Use original income values from asset - DO NOT UPDATE INCOME FOR GROWTH UNITS
      const totalIncome = parseFloat(baseAsset.assetData.monthlyIncome.totalGrossIncome) || 0;
      const netMonthlyIncome = calculateNetMonthlyIncome(totalIncome, totalExpenses);

      return {
        ...baseAsset,
        currentValue: growthFormData.currentValue,
        assetData: {
          ...baseAsset.assetData,
          currentValue: growthFormData.currentValue,
          monthlyIncome: {
            // Keep original income values unchanged for growth units
            ...baseAsset.assetData.monthlyIncome
          },
          monthlyExpenses: {
            ...baseAsset.assetData.monthlyExpenses,
            financing: growthFormData.financing,
            management: growthFormData.management,
            operational: growthFormData.operational,
            fees: growthFormData.fees,
            totalExpenses: totalExpenses.toString()
          },
          netMonthlyIncome: netMonthlyIncome.toString(),
          liabilities: [growthFormData.liability]
        }
      };
    } else {
      const totalIncome = calculateTotalIncome(incomeFormData);
      const totalExpenses = calculateTotalExpenses(incomeFormData);
      const netMonthlyIncome = calculateNetMonthlyIncome(totalIncome, totalExpenses);

      return {
        ...baseAsset,
        currentValue: incomeFormData.currentValue,
        assetData: {
          ...baseAsset.assetData,
          currentValue: incomeFormData.currentValue,
          monthlyIncome: {
            ...baseAsset.assetData.monthlyIncome,
            primary: incomeFormData.primary,
            secondary: incomeFormData.secondary,
            other: incomeFormData.other,
            totalGrossIncome: totalIncome.toString()
          },
          monthlyExpenses: {
            ...baseAsset.assetData.monthlyExpenses,
            financing: incomeFormData.financing,
            management: incomeFormData.management,
            operational: incomeFormData.operational,
            fees: incomeFormData.fees,
            totalExpenses: totalExpenses.toString()
          },
          netMonthlyIncome: netMonthlyIncome.toString(),
          liabilities: [incomeFormData.liability]
        }
      };
    }
  };

  const handleSubmit = async () => {
    if (!asset) return;

    setLoading(true);
    try {
      const updatedAsset = createUpdatedAssetObject();

      const payload = {
        groupId: selectedProjectId || '',
        serviceId,
        unitType,
        asset: updatedAsset
      };

      console.log('Revaluation Payload:', JSON.stringify(payload, null, 2));

      const result = await dispatch(revaluateAsset(payload));

      if (revaluateAsset.fulfilled.match(result)) {
        showSnackbar(
          `${
            unitType === 'growthUnits' ? 'Growth' : 'Income'
          } asset revaluation submitted successfully!`,
          'success'
        );
        onSuccess?.();

        setTimeout(() => {
          handleClose();
        }, 1500);
      } else if (revaluateAsset.rejected.match(result)) {
        const errorMessage = result.payload || 'Failed to submit revaluation';
        showSnackbar(errorMessage, 'error');
        console.error('Revaluation error:', errorMessage);
      }
    } catch (error: any) {
      showSnackbar(error?.message || 'Failed to submit revaluation', 'error');
      console.error('Revaluation error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
      setGrowthFormData({
        currentValue: '',
        financing: '',
        management: '',
        operational: '',
        fees: '',
        liability: defaultLiability
      });
      setIncomeFormData({
        primary: '',
        secondary: '',
        other: '',
        financing: '',
        management: '',
        operational: '',
        fees: '',
        currentValue: '',
        liability: defaultLiability
      });
      setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }));
    }
  };

  const showSnackbar = (message: string, severity: SnackbarState['severity'] = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }));
  };

  const formatCurrency = (amount: string | number): string => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(Number(amount) || 0);
  };

  const getTextFieldStyles = () => ({
    '& .MuiInputLabel-root': {
      fontSize: { xs: '0.75rem', md: '0.875rem' }
    },
    '& .MuiInputBase-input': {
      fontSize: { xs: '0.75rem', md: '0.875rem' },
      py: { xs: 1, md: 1.25 }
    }
  });

  const getSummaryBoxStyles = (bgColor: string, borderColor: string) => ({
    p: { xs: 1.5, md: 2 },
    bgcolor: bgColor,
    borderRadius: 1,
    border: 1,
    borderColor: borderColor,
    mb: { xs: 1.5, md: 2 }
  });

  const renderStaticInformation = () => (
    <Box sx={{ mb: { xs: 2, md: 3 } }}>
      <Typography
        variant="subtitle2"
        gutterBottom
        sx={{
          mb: { xs: 1, md: 1.5 },
          color: 'text.secondary',
          fontSize: { xs: '0.8rem', md: '0.9rem' },
          fontWeight: 600
        }}
      >
        Asset Information (Unchanged)
      </Typography>
      <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

      <Grid container spacing={{ xs: 2, md: 3 }}>
        <Grid item xs={12} sm={4}>
          <Box sx={{ p: { xs: 1.5, md: 2 }, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Asset Type
            </Typography>
            <Typography variant="body2" fontWeight={500} sx={{ textTransform: 'capitalize' }}>
              {asset?.type}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Box sx={{ p: { xs: 1.5, md: 2 }, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Purchase Value
            </Typography>
            <Typography variant="body2" fontWeight={500} color="primary.main">
              {asset ? formatCurrency(asset.assetData.purchaseValue) : ''}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Box sx={{ p: { xs: 1.5, md: 2 }, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Cash Used (Original)
            </Typography>
            <Typography variant="body2" fontWeight={500} color="primary.main">
              {asset ? formatCurrency(asset.assetData.cashUsed) : ''}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );

  const renderMonthlyIncomeSection = (formData: IncomeUnitsFormData, setFormData: any) => (
    <Box sx={{ mb: { xs: 2, md: 3 } }}>
      <Typography
        variant="subtitle2"
        gutterBottom
        sx={{
          mb: { xs: 1, md: 1.5 },
          fontSize: { xs: '0.8rem', md: '0.9rem' },
          fontWeight: 600
        }}
      >
        Monthly Income
      </Typography>
      <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

      <Grid container spacing={{ xs: 2, md: 3 }}>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Primary Income"
            type="number"
            size="small"
            inputProps={{ step: '0.01' }}
            value={formData.primary}
            onChange={(e) =>
              setFormData((prev: any) => ({
                ...prev,
                primary: e.target.value
              }))
            }
            InputProps={{
              startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
            }}
            sx={getTextFieldStyles()}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Secondary Income"
            type="number"
            size="small"
            inputProps={{ step: '0.01' }}
            value={formData.secondary}
            onChange={(e) =>
              setFormData((prev: any) => ({
                ...prev,
                secondary: e.target.value
              }))
            }
            InputProps={{
              startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
            }}
            sx={getTextFieldStyles()}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Other Income"
            type="number"
            size="small"
            inputProps={{ step: '0.01' }}
            value={formData.other}
            onChange={(e) =>
              setFormData((prev: any) => ({
                ...prev,
                other: e.target.value
              }))
            }
            InputProps={{
              startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
            }}
            sx={getTextFieldStyles()}
          />
        </Grid>
      </Grid>

      {/* Auto-calculated Total Gross Income */}
      <Box sx={getSummaryBoxStyles('success.50', 'success.200')}>
        <Typography variant="body2" color="success.main" fontWeight={600}>
          Total Gross Income: {formatCurrency(calculateTotalIncome(formData))}
        </Typography>
      </Box>
    </Box>
  );

  const renderLiabilitySection = (
    liability: Liability,
    updateLiability: (field: keyof Liability, value: string) => void
  ) => (
    <Box sx={{ mt: { xs: 2, md: 3 } }}>
      <Typography
        variant="subtitle2"
        gutterBottom
        sx={{
          mb: { xs: 1, md: 1.5 },
          fontSize: { xs: '0.8rem', md: '0.9rem' },
          fontWeight: 600
        }}
      >
        Liability Information
      </Typography>
      <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

      <Grid container spacing={{ xs: 2, md: 3 }}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Liability Type</InputLabel>
            <Select
              value={liability.type}
              label="Liability Type"
              onChange={(e) => updateLiability('type', e.target.value)}
              sx={getTextFieldStyles()}
            >
              <MenuItem value="financing">Financing</MenuItem>
              <MenuItem value="mortgage">Mortgage</MenuItem>
              <MenuItem value="loan">Loan</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Provider"
            size="small"
            value={liability.provider}
            onChange={(e) => updateLiability('provider', e.target.value)}
            sx={getTextFieldStyles()}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Liability Amount"
            type="number"
            size="small"
            inputProps={{ step: '0.01' }}
            value={liability.amount}
            onChange={(e) => updateLiability('amount', e.target.value)}
            InputProps={{
              startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
            }}
            sx={getTextFieldStyles()}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Interest Rate"
            size="small"
            value={liability.rate}
            onChange={(e) => updateLiability('rate', e.target.value)}
            InputProps={{
              endAdornment: <span style={{ marginLeft: 4, color: 'gray' }}>%</span>
            }}
            sx={getTextFieldStyles()}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Monthly Payment"
            type="number"
            size="small"
            inputProps={{ step: '0.01' }}
            value={liability.monthlyPayment}
            onChange={(e) => updateLiability('monthlyPayment', e.target.value)}
            InputProps={{
              startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
            }}
            helperText="Auto-calculated when amount & rate entered"
            sx={{
              ...getTextFieldStyles(),
              '& .MuiInputBase-input': {
                ...getTextFieldStyles()['& .MuiInputBase-input'],
                bgcolor:
                  liability.monthlyPayment && liability.amount && liability.rate
                    ? 'action.hover'
                    : 'inherit'
              }
            }}
          />
        </Grid>
      </Grid>

      {/* Show calculation hint */}
      {liability.amount && liability.rate && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="caption" color="info.main">
            💡 Monthly payment auto-calculated. Financing expense will be synced automatically.
          </Typography>
        </Box>
      )}
    </Box>
  );

  // Updated Growth Units form - REMOVED Monthly Income section
  const renderGrowthUnitsForm = () => (
    <Box>
      {renderStaticInformation()}

      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{
            mb: { xs: 1, md: 1.5 },
            fontSize: { xs: '0.8rem', md: '0.9rem' },
            fontWeight: 600
          }}
        >
          Asset Valuation
        </Typography>
        <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

        <TextField
          fullWidth
          label="Current Value*"
          type="number"
          size="small"
          inputProps={{ step: '0.01' }}
          value={growthFormData.currentValue}
          onChange={(e) =>
            setGrowthFormData((prev) => ({
              ...prev,
              currentValue: e.target.value
            }))
          }
          InputProps={{
            startAdornment: <MoneyIcon sx={{ mr: 0.5, color: 'text.secondary' }} />
          }}
          helperText="Enter the updated current value of the asset"
          sx={{ ...getTextFieldStyles(), maxWidth: { sm: 400 } }}
        />
      </Box>

      {/* MONTHLY INCOME SECTION HIDDEN FOR GROWTH UNITS */}
      {/* Original income values are preserved in payload automatically */}

      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{
            mb: { xs: 1, md: 1.5 },
            fontSize: { xs: '0.8rem', md: '0.9rem' },
            fontWeight: 600
          }}
        >
          Monthly Expenses
        </Typography>
        <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Financing"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={growthFormData.financing}
              onChange={(e) =>
                setGrowthFormData((prev) => ({
                  ...prev,
                  financing: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              helperText="Syncs with liability payment"
              sx={{
                ...getTextFieldStyles(),
                '& .MuiInputBase-input': {
                  bgcolor: growthFormData.liability.monthlyPayment ? 'action.hover' : 'inherit'
                }
              }}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Management"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={growthFormData.management}
              onChange={(e) =>
                setGrowthFormData((prev) => ({
                  ...prev,
                  management: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              sx={getTextFieldStyles()}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Operational"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={growthFormData.operational}
              onChange={(e) =>
                setGrowthFormData((prev) => ({
                  ...prev,
                  operational: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              sx={getTextFieldStyles()}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Fees"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={growthFormData.fees}
              onChange={(e) =>
                setGrowthFormData((prev) => ({
                  ...prev,
                  fees: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              sx={getTextFieldStyles()}
            />
          </Grid>
        </Grid>

        {/* Auto-calculated totals */}
        <Box sx={getSummaryBoxStyles('grey.50', 'grey.200')}>
          <Typography variant="body2" color="primary" fontWeight={600}>
            Total Monthly Expenses: {formatCurrency(calculateTotalExpenses(growthFormData))}
          </Typography>
        </Box>

        {/* Calculate net income using original asset income values */}
        {asset && (
          <Box sx={getSummaryBoxStyles('info.50', 'info.200')}>
            <Typography variant="body2" color="info.main" fontWeight={600}>
              Net Monthly Income:{' '}
              {formatCurrency(
                calculateNetMonthlyIncome(
                  parseFloat(asset.assetData.monthlyIncome.totalGrossIncome) || 0,
                  calculateTotalExpenses(growthFormData)
                )
              )}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
              Based on original income values (unchanged for growth units)
            </Typography>
          </Box>
        )}
      </Box>

      {renderLiabilitySection(growthFormData.liability, updateGrowthLiability)}
    </Box>
  );

  const renderIncomeUnitsForm = () => (
    <Box>
      {renderStaticInformation()}

      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{
            mb: { xs: 1, md: 1.5 },
            fontSize: { xs: '0.8rem', md: '0.9rem' },
            fontWeight: 600
          }}
        >
          Asset Valuation
        </Typography>
        <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

        <TextField
          fullWidth
          label="Current Value"
          type="number"
          size="small"
          inputProps={{ step: '0.01' }}
          value={incomeFormData.currentValue}
          onChange={(e) =>
            setIncomeFormData((prev) => ({
              ...prev,
              currentValue: e.target.value
            }))
          }
          InputProps={{
            startAdornment: <MoneyIcon sx={{ mr: 0.5, color: 'text.secondary' }} />
          }}
          helperText="Enter the updated current value of the asset"
          sx={{ ...getTextFieldStyles(), maxWidth: { sm: 400 } }}
        />
      </Box>

      {renderMonthlyIncomeSection(incomeFormData, setIncomeFormData)}

      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{
            mb: { xs: 1, md: 1.5 },
            fontSize: { xs: '0.8rem', md: '0.9rem' },
            fontWeight: 600
          }}
        >
          Monthly Expenses
        </Typography>
        <Divider sx={{ mb: { xs: 1.5, md: 2 } }} />

        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Financing"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={incomeFormData.financing}
              onChange={(e) =>
                setIncomeFormData((prev) => ({
                  ...prev,
                  financing: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              helperText="Syncs with liability payment"
              sx={{
                ...getTextFieldStyles(),
                '& .MuiInputBase-input': {
                  bgcolor: incomeFormData.liability.monthlyPayment ? 'action.hover' : 'inherit'
                }
              }}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Management"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={incomeFormData.management}
              onChange={(e) =>
                setIncomeFormData((prev) => ({
                  ...prev,
                  management: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              sx={getTextFieldStyles()}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Operational"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={incomeFormData.operational}
              onChange={(e) =>
                setIncomeFormData((prev) => ({
                  ...prev,
                  operational: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              sx={getTextFieldStyles()}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <TextField
              fullWidth
              label="Fees"
              type="number"
              size="small"
              inputProps={{ step: '0.01' }}
              value={incomeFormData.fees}
              onChange={(e) =>
                setIncomeFormData((prev) => ({
                  ...prev,
                  fees: e.target.value
                }))
              }
              InputProps={{
                startAdornment: <span style={{ marginRight: 4, color: 'gray' }}>$</span>
              }}
              sx={getTextFieldStyles()}
            />
          </Grid>
        </Grid>

        <Box sx={getSummaryBoxStyles('grey.50', 'grey.200')}>
          <Typography variant="body2" color="primary" fontWeight={600}>
            Total Monthly Expenses: {formatCurrency(calculateTotalExpenses(incomeFormData))}
          </Typography>
        </Box>

        <Box sx={getSummaryBoxStyles('info.50', 'info.200')}>
          <Typography variant="body2" color="info.main" fontWeight={600}>
            Net Monthly Income:{' '}
            {formatCurrency(
              calculateNetMonthlyIncome(
                calculateTotalIncome(incomeFormData),
                calculateTotalExpenses(incomeFormData)
              )
            )}
          </Typography>
        </Box>
      </Box>

      {renderLiabilitySection(incomeFormData.liability, updateIncomeLiability)}
    </Box>
  );

  const isFormValid = () => {
    if (unitType === 'growthUnits') {
      return growthFormData.currentValue.trim() !== '';
    }
    return true;
  };

  if (!asset) return null;

  return (
    <>
      <Modal open={open} onClose={handleClose} aria-labelledby="revaluation-modal-title">
        <Paper
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: 700, md: 900 },
            maxWidth: '95vw',
            maxHeight: '90vh',
            overflow: 'auto',
            p: 0,
            borderRadius: { xs: 1, md: 2 }
          }}
        >
          <Box
            sx={{
              p: { xs: 2, md: 3 },
              borderBottom: 1,
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: 'grey.50'
            }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              {unitType === 'growthUnits' ? (
                <TrendingUpIcon color="primary" sx={{ fontSize: '1.5rem' }} />
              ) : (
                <MoneyIcon color="primary" sx={{ fontSize: '1.5rem' }} />
              )}
              <Box>
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{ fontSize: { xs: '1.1rem', md: '1.3rem' }, fontWeight: 600, mb: 0.5 }}
                >
                  {unitType === 'growthUnits' ? 'Growth' : 'Income'} Asset Revaluation
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                  {asset.assetData.identifier}
                </Typography>
              </Box>
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
              <Chip
                label={unitType === 'growthUnits' ? 'Growth Unit' : 'Income Unit'}
                size="small"
                color="primary"
                variant="outlined"
              />
              <IconButton onClick={handleClose} size="small" disabled={loading}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ p: { xs: 2, md: 3 } }}>
            {unitType === 'growthUnits' ? renderGrowthUnitsForm() : renderIncomeUnitsForm()}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 2,
                mt: 4,
                pt: 2,
                borderTop: 1,
                borderColor: 'divider'
              }}
            >
              <Button
                variant="outlined"
                onClick={handleClose}
                disabled={loading}
                sx={{ minWidth: 100 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading || !isFormValid()}
                startIcon={loading && <CircularProgress size={20} />}
                sx={{ minWidth: 150 }}
              >
                {loading ? 'Submitting...' : 'Submit Revaluation'}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RevaluationModal;
